import { api } from "../api";
import { ICartaoView } from "shared/interfaces/IMetodo";
import { IInstallment } from "shared/interfaces/IMetodo";

/* ================================
   BUSCAR CARTÕES
================================ */

export const buscarCartoes = async (): Promise<ICartaoView[]> => {
  const response = await api.get(`/identity/cards`);
  if (!Array.isArray(response.data) || response.data.length === 0) return [];
  return response.data.map((cartao) => ({
    id: cartao.id,
    ultimos4digitos: cartao.last4,
    marca: cartao.brand,
    nome: cartao.holderName,
    validade: `${cartao.expMonth}/${cartao.expYear}`,
    bandeira: cartao.brandImageUrl,
    defaultCard: cartao.isDefault,
  }));
};

/* ================================
   CRIAR CARTÃO
================================ */

export const criarCartao = async (pagarmeToken: string) => {
  const payload = {
    cardToken: pagarmeToken,
  };

  const response = await api.post(`/identity/cards`, payload);
  return response.data;
};

/* ================================
   EXCLUIR CARTÃO
================================ */

export const excluirCartao = async (id: string) => {
  await api.delete(`/identity/cards/${id}`);
};

/* ================================
   DEFINIR PADRÃO
================================ */

export const definirCartaoPadrao = async (id: string) => {
  await api.patch(`/identity/cards/${id}/default`);
};

/* ================================
   SIMULAR PARCELAMENTO
================================ */

export const buscarSimulacaoParcelas = async (
  amount: number,
): Promise<IInstallment[]> => {
  // v2: parcelas sobre o carrinho com o preço das combinações.
  const response = await api.get("/v2/orders/simulation"); // TODO Loose end: Here was being sent the "amount" param. Should be removed from compenent that makes the call

  return response.data.data;
};
